// extracted by mini-css-extract-plugin
module.exports = {"formulario":"formularioContacto-module--formulario--1IZTd","titulo":"formularioContacto-module--titulo--3vum-","subtitulo":"formularioContacto-module--subtitulo--1Sk7Q"};